import manifest from "./musicas.generated.json";

function unique(list) {
  return Array.from(new Set((list || []).filter(Boolean)));
}

const todas = unique(manifest?.all || []);
const byMood = manifest?.by_mood || {};

function withFallback(list) {
  const clean = unique(list);
  return clean.length > 0 ? clean : todas;
}

export const todasMusicas = todas;

export const musicas = {
  epico: withFallback(byMood.epico),
  calmo: withFallback(byMood.calmo),
  apreensivo: withFallback(byMood.apreensivo),
  tragico: withFallback(byMood.tragico),
};
